module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-banner.6c6a56d6.jpg";